import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Layout from '../components/layout';
import ContactUsModal from '../components/contactUsModal';
import styles from '../styles/specification.module.scss';
import Image from 'next/image';

export default function Cloud() {
  const router = useRouter();
  const { t } = useTranslation('hardware');

  const returnTable = (numOfRows, name) => (<div className={styles['table-wrap']}>
    <table>
      <thead>
        <tr>
          <th style={{width: '24%'}}>{t('title1')}</th>
          <th style={{width: '38%'}}>{t('title2')}</th>
          <th style={{width: '38%'}}>{t('title3')}</th>
        </tr>
      </thead>
      <tbody>
        { new Array(numOfRows).fill('').map((_, index) => <tr key={index}>
          <td style={{width: '24%'}}>{t(`${name}1.row${index + 1}`)}</td>
          <td style={{width: '38%'}}>{t(`${name}2.row${index + 1}`)}</td>
          <td style={{width: '38%'}}>{t(`${name}3.row${index + 1}`)}</td>
        </tr>)}
      </tbody>
    </table>
  </div>);

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
      <div className={styles.model}>
        <section className={styles.specification}>
          <div className={styles.blur}>
            <Image src='/general.webp' alt='General' layout='fill' objectFit='cover' unoptimized priority />
          </div>
          <div className={router.locale + ' ' + styles.specification_info}>
            <h1 className={styles.title}>{t('titleHardware')}</h1>
              <p className={styles.description}>{t('description')}</p>
              <div className={styles.button_block}>
                <ContactUsModal lang={router.locale} />
              </div>
            </div>
        </section>
        <section className={styles.content}>
          <div className={'flex ' + styles.wrapper}>
            <div className={styles.info}>
              <h2>{t('nodes_title')}</h2>
              {returnTable(7, 'nodes_col')}
              <p>{t('reference_hardware1')}</p>
              <h2>{t('storage_title')}</h2>
              {returnTable(8, 'storage_col')}
              <p>{t('reference_hardware2')}</p>
              <p><b>{t('notes')}</b><br />{t('note1')}</p>
            </div>
            <div className={styles.image_container}>
              <Image src='/server.webp' alt='Server' loading='lazy' width={264} height={600} />
            </div>
          </div>
          <h2>{t('networking')}</h2>
          <div className={styles.networking}>
            <div>
              <p><b>{t('l3switch_title')}</b></p>
              <p dangerouslySetInnerHTML={{__html: t('l3switch_description', { interpolation: { escapeValue: false }})}} />
            </div>
            <div>
              <p><b>{t('management_switch_title')}</b></p>
              <p dangerouslySetInnerHTML={{__html: t('management_switch_description', { interpolation: { escapeValue: false }})}} />
              <p><b>{t('internet_title')}</b></p>
              <p dangerouslySetInnerHTML={{__html: t('internet_description', { interpolation: { escapeValue: false }})}} />
            </div>
          </div>
        </section>        
      </div>
      <style jsx>{`
        .ru {
          max-width: 774px;
        }
        .en {
          max-width: 672px;
        }
      `}</style>
    </Layout>
  )
};

export const getStaticProps = async ({ locale }) => ({
    props: {
      ...await serverSideTranslations(locale, ['hardware', 'common']),
    }
});
